import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

const python = `import http.client

conn = http.client.HTTPSConnection("baseUrl")
headers = {
  'Authorization': 'Bearer <access_token>'
}
conn.request(
  "GET",
  "/api/External/GetEvents?FilterValue=&FilterType=0&EventTypes=&Skip=0&Take=50",
  '',
  headers
)
res = conn.getresponse()
data = res.read()
print(data.decode("utf-8"))
`;

function HTTPCRC() {
  return (
    <Highlight
      {...defaultProps}
      theme={theme}
      code={python}
      language="javascript"
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default HTTPCRC;
